import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { analysisData } from '../../Redux/Slices/adminPortalSlice';
import ReactLoading from 'react-loading';
import Doughnut4 from '../../Charts/Doughnut4';
import StackedChart from '../../Charts/StackedChart';
import './EpisodeAnalysis.css';

function EpisodesAnalysis() {
    let data = useSelector(analysisData)

    if (data === 'unloaded') {
        return (
            <div className="EpisodeAnalysis_loadingDiv">
                <ReactLoading type={'bubbles'} color={'#00695f'} height={100} width={100} />
            </div>
        )
    } else {
        return (
            <>
                <div className='EpisodeAnalysis_dashboardDiv1'>
                    <div className='EpisodeAnalysis_clickedUser_div1'>
                        <div className='EpisodeAnalysis_clikedUser_details'>
                            <div className='EpisodeAnalysis_clickedUserNumber'>{`${data.episodeAnalysis.episode1.episode1_ClickedUsers}`}</div>
                            <div className='EpisodeAnalysis_clickedStats'>{`${((data.episodeAnalysis.episode1.episode1_ClickedUsers / data.loginUsers) * 100).toFixed(2)} % of login users`}</div>
                        </div>
                        <div className='EpisodeAnalysis_clickedUserFooter'>Episode 1 Clicked Users</div>
                    </div>

                    <div className='EpisodeAnalysis_clickedUser_div2'>
                        <div className='EpisodeAnalysis_clikedUser_details'>
                            <div className='EpisodeAnalysis_clickedUserNumber'>{`${data.episodeAnalysis.episode2.episode2_ClickedUsers}`}</div>
                            <div className='EpisodeAnalysis_clickedStats'>{`${((data.episodeAnalysis.episode2.episode2_ClickedUsers / data.loginUsers) * 100).toFixed(2)} % of login users`}</div>
                        </div>
                        <div className='EpisodeAnalysis_clickedUserFooter'>Episode 2 Clicked Users</div>
                    </div>

                    <div className='EpisodeAnalysis_clickedUser_div3'>
                        <div className='EpisodeAnalysis_clikedUser_details'>
                            <div className='EpisodeAnalysis_clickedUserNumber'>{`${data.episodeAnalysis.episode3.episode3_ClickedUsers}`}</div>
                            <div className='EpisodeAnalysis_clickedStats'>{`${((data.episodeAnalysis.episode3.episode3_ClickedUsers / data.loginUsers) * 100).toFixed(2)} % of login users`}</div>
                        </div>
                        <div className='EpisodeAnalysis_clickedUserFooter'>Episode 3 Clicked Users</div>
                    </div>
                </div>

                <div className='EpisodeAnalysis_dashboardDiv2'>
                    <div className="EpisodeAnalysis_episodesCompleteSection" >
                        <Doughnut4 />
                    </div>

                    <div className="EpisodeAnalysis_episodesAvgScoreSection" >
                        <StackedChart />
                    </div>
                </div>
            </>
        )
    }
}
export default EpisodesAnalysis;